import { FlowChartState } from 'common/builder/components/chart/FlowChart/types/FlowChartState'
import { IFlow } from 'common/flow/flowInterfaces'
import FlowModel from 'common/flow/models/Flow'

export const useGetViewerFlowChartState = ({
  flow,
  isPlayer,
  selectedTriggerId,
  selectedNodesMap,
}: {
  flow?: IFlow
  isPlayer?: boolean
  selectedTriggerId: string | null
  selectedNodesMap: Record<string, boolean>
}): FlowChartState => {
  const isReadonly = true

  const flowChartState: FlowChartState = {
    isReadonly,
    isNoStats: Boolean(isPlayer),
    isPlayer: Boolean(isPlayer),
    isAiAssistantMode: false,
    isNoInteractions: false,
    isPublished: FlowModel.hasPublishedContent(flow),
    isCreateTriggerAllowed: false,
    selectedTrigger: selectedTriggerId,
    selectedNodes: selectedNodesMap,
  }

  return flowChartState
}
